export function validateSspBeforeUpsert(values: Record<string, unknown>): void {
  if (Number(values.margin) > 0 && Number(values.revenueSharePercent) > 0) {
    throw new Error(
      'Both "Margin" and "Revenue Share Percent" cannot be set to values greater than 0 simultaneously. To proceed, ensure that at least one of these fields is set to 0.'
    );
  }
}
